module.exports = "/_next/static/images/InternalSecurity@2x-3772707ab15f342bed799ddf29231ea3.png";